// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';
import Cookies from 'universal-cookie';
export const initialState = {
    cart: [], //JSON.parse(localStorage.getItem('cart')) // for active default menu
    customer: {},
    paymentType: '',
    billing: {},
    wallet: {},
    reference: {},
    premiums:[],
    images: []
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const CartReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.Add_Cart:
            return {
                ...state,
                cart: action.cart
            };
        case actionTypes.Add_Customer:
            return {
                ...state,
                customer: action.customer
            };
        case actionTypes.Add_PaymentType:
            return {
                ...state,
                paymentType: action.paymentType
            };
        case actionTypes.Add_Billing:
            return {
                ...state,
                billing: action.billing
            };
        case actionTypes.Add_Wallet:
            return {
                ...state,
                wallet: action.wallet
            };
        case actionTypes.Add_Reference:
            return {
                ...state,
                reference: action.reference
            };
        case actionTypes.Add_Premiums:
            return {
                ...state,
                premiums: action.premiums
            };
        case actionTypes.Add_Images:
            return {
                ...state,
                images: action.images
            };
        default:
            return state;
    }
};

export default CartReducer;
